// A module that can be used for all components instead of creating a new one for each component
angular.module('edxComponents', []);